import { SyntheticEvent } from "react";

interface CoastFeedCategorySelectorProps {
  handleChange(e: SyntheticEvent): void;
  selectedLetter?: string;
}

export const CoastAlphabeticalSelector = ({ selectedLetter = "A", handleChange }: CoastFeedCategorySelectorProps) => (
  <div className="coast-feed-navigation-filter">
    {/* Using onBlur here makes react mad */}
    {/* eslint-disable-next-line jsx-a11y/no-onchange */}
    <select name="letter" onChange={handleChange} value={selectedLetter}>
      <option key="Select Letter" label={"Select Letter"} value={""}>
        Select Letter
      </option>
      {[..."abcdefghijklmnopqrstuvwxyz"].map(letter => (
        <option key={letter} label={letter.toUpperCase()} value={letter}>
          {letter.toUpperCase()}
        </option>
      ))}
    </select>
  </div>
);
